import { Button, Checkbox, Form, Input } from '@bynder/design-system';
import { IconCheck, IconPublic, IconTimeline } from '@bynder/icons';
import type { Dispatch, SetStateAction } from 'react';
import type { LinkEditorState } from './link-editor.tsx';

type EditLinkProps = {
  linkEditorState: LinkEditorState;
  setLinkEditorState: Dispatch<SetStateAction<LinkEditorState>>;
};

export const EditLink = ({
  linkEditorState: { href, text, target },
  setLinkEditorState,
}: EditLinkProps) => (
  <>
    <Form.Group>
      <Input
        aria-label="hyperlink text"
        placeholder="Text"
        icon={<IconTimeline />}
        value={text}
        onChange={(newValue) => {
          setLinkEditorState((prev) => ({ ...prev, text: newValue }));
        }}
        hasClearButton
      />
    </Form.Group>
    <Form.Group>
      <Form.InputRow>
        <Input
          aria-label="hyperlink url"
          placeholder="Paste a link"
          icon={<IconPublic />}
          value={href ?? ''}
          onChange={(newValue) => {
            setLinkEditorState((prev) => ({ ...prev, href: newValue }));
          }}
          hasClearButton
        />
        <Button
          variant="clean"
          aria-label="Save link"
          type="submit"
          isDisabled={!href}
          icon={<IconCheck />}
        />
      </Form.InputRow>
    </Form.Group>
    <Form.Group>
      <Checkbox
        isChecked={Boolean(target)}
        onChange={(formEvent) => {
          const target = formEvent.currentTarget;
          setLinkEditorState((prev) => ({
            ...prev,
            target: target.checked ? '_blank' : null,
          }));
        }}
        id={'open-in-new-tab'}
      >
        Open in new tab
      </Checkbox>
    </Form.Group>
  </>
);
